import script from "./PublishPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishPage.vue?vue&type=script&setup=true&lang=js"

import "./PublishPage.vue?vue&type=style&index=0&id=0bfd915a&lang=css"
import "./PublishPage.vue?vue&type=style&index=1&id=0bfd915a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfd915a"]])

export default __exports__